$(document).on('submit', 'form.form-inline', function (event) {
    event.preventDefault();

    let url = $(this).attr('action');
    let cont = $(this).parents('.form-container');

    let theme = $(cont).find('.form-theme').html().trim();

    if (typeof theme == "string") {
        $(this).find("input[name=theme]").val(theme);
    }

    $.post(url, $(this).serialize(), function (cont, data) {
        if (data.errors) {
            $(this).find('.input__error').remove();
            $(this).find('.form__input.error').removeClass('error');

            $.each(data.errors, function (name, error) {
                let input = $(cont).find("input[name=" + name + "]");
                $(input).after($("<span/>").addClass('input__error').html(error)).addClass('error');
            });
        } else if (data.id) {
            $(this).find('input').val('');
            $(this).find('textarea').html('');

            $(cont).find('.form-content').hide();
            $(cont).find('.form-success').show();

            if (typeof ym === 'function' && window.metrica_id) {
                ym(window.metrica_id, 'reachGoal', 'click-forms-send');
            }
        }
    }.bind(this, cont));
});
